import { useIonModal } from '@ionic/react';
import { DateTime } from 'luxon';
import { FullPost } from 'model';
import { useState } from 'react';
import { usePurchasePromotionMutation } from '../api/UserLedgerAPI.js';
import { useGetPromotionValues } from '../hooks/useGetPromotionValues.js';
import { Confirmation } from '../pages/Confirmation.js';
import { IconButton } from './IconButton.js';
import { IconQuirktoken } from './QuirkIcons/index.js';
// eslint-disable-next-line css-modules/no-unused-class
// eslint-disable-next-line css-modules/no-unused-class
import styles from './PromotePost.module.css';
import { PromotionCreate } from './PromotionCreate.js';

interface reportPostType {
	post: FullPost;
	hideTooltip?: () => void;
	feed?: boolean;
}

export const PromotePost: React.FC<reportPostType> = ({ post, hideTooltip, feed }) => {
	const [promotionDates, setPromotionDates] = useState<{
		promotionStartDate: string | null;
		promotionEndDate: string | null;
	}>({
		promotionStartDate: DateTime.now().toUTC().toISO().substring(0, 10),
		promotionEndDate: DateTime.now().plus({ days: 1 }).toUTC().toISO().substring(0, 10)
	});

	const [showAlert, setShowAlert] = useState(false);
	const { promotionStartDate, promotionEndDate } = promotionDates;
	const { totalTokenCost, balanceAfterPromotion, userBalance } = useGetPromotionValues({
		userid: post?.author,
		startDate: promotionStartDate,
		endDate: promotionEndDate
	});

	const [purchasePromotion] = usePurchasePromotionMutation();

	const createPromotion = () => {
		if (promotionStartDate && promotionEndDate && userBalance && userBalance >= balanceAfterPromotion) {
			purchasePromotion({ postId: post._id, startDate: promotionStartDate, endDate: promotionEndDate });
			dismiss();
			hideTooltip && hideTooltip();
		} else {
			setShowAlert(true);
		}
	};

	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => dismiss(),
		action: createPromotion,
		cancelAction: hideTooltip,
		actionLabel: 'Promote',
		dismissLabel: 'Cancel',
		content: (
			<PromotionCreate
				post={post}
				promotionStartDate={promotionStartDate}
				promotionEndDate={promotionEndDate}
				setPromotionDates={setPromotionDates}
				promotionDates={promotionDates}
				totalTokenCost={totalTokenCost}
				balanceAfterPromotion={balanceAfterPromotion}
				setShowAlert={setShowAlert}
				showAlert={showAlert}
			/>
		)
	});

	return (
		<div className={'quirkToken'}>
			{feed ? (
				<div className={styles.promoteLabelContainer}>
					<div
						data-testid={'PromotePostButton-' + post._id}
						className={styles.promoteLabel}
						onClick={() => present()}
					>
						<span>Promote this post</span>
						<span>
							<IconQuirktoken />
						</span>
					</div>
				</div>
			) : (
				<IconButton
					testId={'PromotePostButton-' + post._id}
					label="Promote"
					icon={<IconQuirktoken />}
					onClick={present}
				/>
			)}
		</div>
	);
};
